import { render, staticRenderFns } from "./FinalizacoesDash.vue?vue&type=template&id=5b14aaae"
import script from "./FinalizacoesDash.vue?vue&type=script&lang=js"
export * from "./FinalizacoesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports